import { Component, OnInit, ViewChild, Renderer } from '@angular/core';
import { GameComponent } from '../game/game.component';
import { Router, ActivatedRoute } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SocketService } from '../shared/services/socket.service';
import { Message } from '../shared/model/message';
import { MessageType } from '../shared/model/message-type';
import { HttpClient } from '@angular/common/http';
import { getServerUrl } from '../shared/utils/utils';
import { GameStatus } from '../shared/model/game-status';
import { DrawingPadComponent } from '../drawing-pad/drawing-pad.component';

@Component({
  selector: 'pbg-telestrations',
  templateUrl: './telestrations.component.html',
  styleUrls: ['./telestrations.component.scss']
})
export class TelestrationsComponent extends GameComponent implements OnInit {
  @ViewChild('guessPicture')
  guessPicture;
  @ViewChild('drawingPad')
  drawingPad: DrawingPadComponent;
  isDrawMode = false;
  isGuessMode = false;
  pictureHash = '';
  wordToDraw = '';
  guess = '';
  waitMode = false;
  expiration: number;
  timeLimit: number;

  constructor(
    socketService: SocketService,
    cookieService: CookieService,
    router: Router,
    resolver: ActivatedRoute,
    public httpClient: HttpClient
  ) {
    super(socketService, cookieService, router, resolver);
  }

  messageHandler(m: Message) {
    if (
      m.action === MessageType.Prompt ||
      (m.action === MessageType.Host && m.content.status === GameStatus.InProgress)
    ) {
      this.requestPrompt();
    }
  }

  sendResponse(message: string): void {
    this.waitMode = true;
    this.isDrawMode = false;
    this.isGuessMode = false;

    const submission = {
      answer: message
    };

    this.socketService.send({
      from: this.user,
      content: submission,
      action: MessageType.Response,
      gameId: this.gameId
    });

    this.guess = '';
  }

  timerChangeHandler(timerStatus) {
    if (timerStatus.status.ended) {
      if (this.isDrawMode) {
        this.sendResponse(this.drawingPad.getCurrentDrawing());
      } else {
        this.sendResponse(this.guess);
      }
    }
  }

  requestPrompt() {
    const url = `${getServerUrl(this.gameId)}/request-prompt`;
    const body = {
      gameId: this.gameId,
      username: this.user.name
    };

    this.httpClient.request('post', url, { body }).subscribe(
      (resp: any) => {
        if (resp.success) {
          console.log(resp);
          if (resp.hasSubmitted) {
            this.isDrawMode = false;
            this.isGuessMode = false;
            this.wordToDraw = '';
            this.pictureHash = '';
            this.waitMode = true;
          } else if (resp.promptType === 'draw') {
            this.isDrawMode = true;
            this.isGuessMode = false;
            this.wordToDraw = resp.prompt;
            this.waitMode = false;
            this.showWaiting = false;
            this.expiration = resp.expiration;
            this.timeLimit = resp.timeLimit;
          } else {
            this.isDrawMode = false;
            this.isGuessMode = true;
            this.pictureHash = resp.prompt;
            this.waitMode = false;
            this.showWaiting = false;
            this.expiration = resp.expiration;
            this.timeLimit = resp.timeLimit;
          }
        } else {
          console.log('aww shit...');
        }
      },
      error => {
        console.log(error);
      }
    );
  }
}
